import React from 'react';
import ProductPage from '../components/product-page';

export default function BscPage() {
  return (
    <ProductPage
      title="RDM Conformance Tester"
      className="smart-power-theater"
      images={[
        {
          src: 'rdm.png',
          alt:
            'Computer Monitor showing RDM Conformance Tester Softer on screen',
        },
        {
          src: 'rdm-interface.png',
          alt: 'Overview of interface',
        },
        {
          src: 'rdm-test-results-advisory.png',
          alt: 'Detailed view showing results of tests that passed or failed',
        },
        {
          src: 'rdm-dmx-controller.png',
          alt: 'View of rdm controller build into testing software',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              <p>
                The RDM Responder Conformance Test is a Windows Application that
                performs tests on products claiming compliance with the ANSI
                E1.20 -2010 [Remote Device Management over DMX512 Networks] and
                ANSI E1.37-1 [Additional Message Sets for ANSI E1.20 (RDM) –
                Part 1, Dimmer Message Sets] standards and seeks to evaluate a
                product's compliance with those documents.
              </p>
              <p>
                The tests provide a clear determination of Pass, Fail, Warning
                or Advisory levels together with the decoded Parameter Data for
                all command classes and Parameter ID’s (PIDs).
              </p>
              <p style={{ marginBottom: 0 }}>
                The RDM Responder Conformance Test is targeted at manufacturers
                and developers wishing to ensure that product is compliant
                before being placed on the market, but will be equally useful to
                technical sales consultants and commissioning engineers wishing
                to verify that market claims of RDM compatibility are indeed
                being met. Compliance with standards improves the
                interoperability of products and greatly enhances the end user
                experience.
              </p>
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>Results can be exported for use in subsequent reports.</li>
              <li>
                Filtering by result levels allows the user to isolate messages
                for detailed analysis.
              </li>
              <li>
                Displays transmit and receive raw data in an easy to read format
                for debugging.
              </li>
              <li>
                Manufacturer or Custom PID messages can also be transmitted and
                the responses analyzed.
              </li>
              <li>
                Optional validation of message by message timing is available in
                conjunction with the Goddard Design interfaces. Extensive
                testing of a responder’s behavior in the presence is format
                errors and data range boundary conditions is provided, as is
                support for messages sent to Sub-Devices.
              </li>
              <li>
                The application may be used on a DMX network having multiple
                responders by selecting a “Responder to Test” from a list of
                discovered devices. Alternatively it may automatically connect
                to a single responder. A simple DMX control interface allows RDM
                testing with and without interleaved DMX packets.
              </li>
            </ul>
          ),
        },
        {
          title: 'Requirements',
          id: 'requirements',
          content: (
            <p>
              The application runs on all Windows platforms through a standard
              USB port in conjunction with either a{' '}
              <a href="https://www.jese.co.uk/product/001/">JESE Ltd TRI MK1</a>{' '}
              or{' '}
              <a href="http://www.goddarddesign.com/dmxter4a.html">
                Goddard Design DMXter4 series USB-RDM interface
              </a>
              . The Artistic License{' '}
              <a href="https://artisticlicence.com/product/netlynx-quad/">
                netLynx quad
              </a>
              ,{' '}
              <a href="https://artisticlicence.com/product/artlynx/">
                artLynx quad
              </a>{' '}
              or{' '}
              <a href="https://artisticlicence.com/product/datalynx-ii/">
                dataLynx
              </a>{' '}
              may also be used.
            </p>
          ),
        },
        {
          title: 'Support',
          id: 'support',
          content: 'Use Contact/Sales page for support.',
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/rdm_integrity-product_sheet.pdf">
                  Product Sheet
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
